module.exports = __webpack_public_path__ + "static/img/follow-up-item.be5e6cde.png";